import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';

import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { keyBy, each, indexOf, values, reduce, find } from 'lodash';
import ProgressBar from '../../../../components/progress-bar';
import requiredSync from '../../../../components/required-sync';
import orgAwearness from '../../../../components/organization-awearness';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getPrograms, getProgramLoading, getProgramLoaded } from '../../NominationReducer';
import { fetchPrograms } from '../../NominationActions';
import createWLComponent from './WinLoss';
import createCEComponent from './CustomerExperience';
import MarketResearchPage from './MarketResearch';
import { getAvailablePrograms } from '../../components/nav';

const WinLossPage = createWLComponent('Win Loss');
const VoiceOfBuyerPageWL = createWLComponent('Voice of the Buyer');
const CustomerExperiencePage = createCEComponent('Customer Experience');
const VoiceOfBuyerPageCE = createCEComponent('Voice of the Buyer');

class NominationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.props.dispatch(fetchPrograms());
  }

  render() {
    const {
      loading, loaded, programs, userCurrentOrganization, location: { pathname },
    } = this.props;

    if (loading) {
      return (<div className="container"><ProgressBar /></div>);
    }
    if (!loaded) {
      return null;
    }

    const components = {
      'win-loss': WinLossPage,
      'customer-experience': CustomerExperiencePage,
      'market-research': MarketResearchPage,
      'voice-of-the-buyer/accounts': VoiceOfBuyerPageCE,
      'voice-of-the-buyer/opportunities': VoiceOfBuyerPageWL,
    };

    const availablePrograms = getAvailablePrograms(programs);
    const validPaths = reduce(availablePrograms, (items, ap) => {
      items.push(ap.url);
      if (ap.children && ap.children.length) {
        each(ap.children, (sub) => {
          items.push(sub.url);
        });
      }
      return items;
    }, []);

    const hasPrograms = validPaths.length > 0;
    if (indexOf(validPaths, pathname) < 0) {
      if (hasPrograms) {
        return (<Redirect to={validPaths[0]} />);
      }
      return (<Redirect to="/" />);
    }

    return (
      <div>
        <Helmet title="Nominations" />
        <div className="container">
          <h1 className="page-header">
            Nominations
          </h1>
          {!hasPrograms &&
            <div className="alert alert-danger">
              This feature is not enabled for <strong>{userCurrentOrganization.display_name}</strong>.
            </div>
          }
        </div>
        {hasPrograms &&
          <Switch>
            {availablePrograms.map((availableProgram) => {
              const Comp = components[availableProgram.slug];
              if (Comp) {
                return (
                  <Route
                    key={availableProgram.id}
                    path={availableProgram.url}
                    render={(props) => {
                      return (
                        <Comp
                          key={availableProgram.id}
                          programId={availableProgram.program_id}
                          subNav={availableProgram.children}
                          {...props}
                        />
                      );
                    }}
                  />
                );
              }
              return null;
            })}
          </Switch>
        }
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    userCurrentOrganization: getUserCurrentOrganization(state),
    programs: getPrograms(state),
    loading: getProgramLoading(state),
    loaded: getProgramLoaded(state),
  };
}

NominationPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userCurrentOrganization: PropTypes.shape({}),
  location: PropTypes.shape({}).isRequired,
  programs: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
};
NominationPage.defaultProps = {
  userCurrentOrganization: null,
};

NominationPage.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(orgAwearness(requiredSync(NominationPage))));
